import * as z from "zod";

export const publishContentGeneratorConfig = {
  name: "publishContentGeneratorConfig" as const,
  input: z.object({ configId: z.string().min(1, "Config ID is required") }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
